import React from "react";
import { DateTime } from "luxon";
import { Card } from "antd";
import InfoCard from "components/cards/info";

export default function ClientCard({ client }) {
  const formatedTimeOfBirth = client.timeOfBirth
    ? DateTime.fromISO(client.timeOfBirth).toFormat("HH:mm")
    : null;
  const formatedDateOfBirth = client.dateOfBirth
    ? DateTime.fromFormat(client.dateOfBirth, "yyyy-MM-dd").toFormat(
        "dd.MM.yyyy"
      )
    : null;

  return (
    <Card title="Client info" style={{ width: "100vw" }}>
      <InfoCard label="id">{client.id}</InfoCard>
      <InfoCard label="name">{client.firstName}</InfoCard>
      <InfoCard
        label="spent credits"
        type={client.spentCreditsCount > 1000 && "warning"}
      >
        {client.spentCreditsCount}
      </InfoCard>
      <InfoCard label="date of birth">{formatedDateOfBirth}</InfoCard>
      <InfoCard label="time of birth">{formatedTimeOfBirth}</InfoCard>
      <InfoCard label="place of birth">{client.placeOfBirth}</InfoCard>
      <InfoCard label="gender">{client.gender}</InfoCard>
      <InfoCard label="marital status">{client.maritalStatus}</InfoCard>
    </Card>
  );
}
